import React from 'react';
import { DocumentsTabChart } from 'javascripts/analytics/components/documents_tab_chart';
import { NoDataTab } from 'javascripts/analytics/components/NoDataTab';
import { DocumentsTabTable } from './documents_tab_table';

export class DocumentsTabContainer extends React.Component {
  getStateFromStore = () => {
    return {
      docs: Aedu.ReduxStore.getState().AnalyticsDashboard.Works,
      downloads: Aedu.ReduxStore.getState().AnalyticsDashboard.Downloads,
      previousDateRangeDownloads:
        Aedu.ReduxStore.getState().AnalyticsDashboard
          .PreviousDateRangeDownloads,
      hits: Aedu.ReduxStore.getState().AnalyticsDashboard.Hits,
      previousDateRangeHits:
        Aedu.ReduxStore.getState().AnalyticsDashboard.PreviousDateRangeHits,
      displayedDates:
        Aedu.ReduxStore.getState().AnalyticsDashboard.DisplayedDates,
    };
  };

  state = this.getStateFromStore();

  componentDidMount() {
    this.unsubscribe = Aedu.ReduxStore.subscribe(
      function () {
        this.setState(this.getStateFromStore());
      }.bind(this),
    );

    Aedu.ReduxStore.dispatch(
      Aedu.ActionCreators.AnalyticsDashboard.Works.fetch(),
    );
    Aedu.ReduxStore.dispatch(
      Aedu.ActionCreators.AnalyticsDashboard.Downloads.fetch(),
    );
    Aedu.ReduxStore.dispatch(
      Aedu.ActionCreators.AnalyticsDashboard.Hits.fetch(),
    );
    Aedu.ReduxStore.dispatch(
      Aedu.ActionCreators.AnalyticsDashboard.PreviousDateRangeHits.fetch(),
    );
    Aedu.ReduxStore.dispatch(
      Aedu.ActionCreators.AnalyticsDashboard.PreviousDateRangeDownloads.fetch(),
    );
  }

  componentWillUnmount() {
    this.unsubscribe();
  }

  render() {
    const fetching =
      this.state.docs.meta.fetching || this.state.downloads.meta.fetching;
    if (fetching) {
      return (
        <div className="u-taCenter u-pv4x">
          <i className="fa fa-spin fa-spinner u-fs36"></i>
        </div>
      );
    } else if (this.state.docs.models.length) {
      return (
        <div>
          <DocumentsTabChart
            downloads={this.state.downloads.models}
            hits={this.state.hits.models}
            startDate={this.state.displayedDates.start}
            previousDateRangeDownloads={
              this.state.previousDateRangeDownloads.models
            }
            previousDateRangeHits={this.state.previousDateRangeHits.models}
            dayCount={this.state.displayedDates.dayCount}
          />
          <DocumentsTabTable
            match={this.props.match}
            docs={this.state.docs.models}
            dayCount={this.state.displayedDates.dayCount}
          />
        </div>
      );
    } else {
      return (
        <NoDataTab
          title="You haven't added any papers yet."
          details="Upload your work to find out how many people read your papers,<br>what countries they come from, what search terms they use, and more."
          loggedOutTitle={
            Aedu.User.viewed.display_name + "  hasn't uploaded any papers yet."
          }
        />
      );
    }
  }
}
